export default __webpack_public_path__ + "static/media/building.c65ac398.svg";